import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Route guard — redirects to /worklist when the user lacks the required permission. */
export function permissionGuard(permission: string): CanActivateFn {
    return () => {
        const auth = inject(AuthService);
        const router = inject(Router);
        if (auth.hasPermission(permission)) {
            return true;
        }
        return router.createUrlTree(['/worklist']);
    };
}

/** Route guard — passes when the user holds ANY of the permissions; else redirects to /worklist. */
export function anyPermissionGuard(permissions: string[]): CanActivateFn {
    return () => {
        const auth = inject(AuthService);
        const router = inject(Router);
        if (permissions.some((p) => auth.hasPermission(p))) {
            return true;
        }
        return router.createUrlTree(['/worklist']);
    };
}
